var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.parentForm
    ? _c(
        "div",
        { key: _vm.parentForm.updated_at, staticClass: "px-6" },
        [
          _c(
            "div",
            {
              staticClass:
                "sticky top-34 z-10 flex items-center justify-between bg-pure-white pt-4 pb-3 cursor-pointer",
              on: {
                click: function($event) {
                  _vm.movingSection = !_vm.movingSection
                }
              }
            },
            [
              _c("BlTextBody2", {
                attrs: { text: "Showing " + _vm.numberOfBlocks + " block(s)" }
              }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("BlIcon", {
                    staticClass: "w-5 h-5 transition-all duration-300",
                    style: { rotate: _vm.movingSection ? "180deg" : "" },
                    attrs: { icon: "chevron-up" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "draggable",
            {
              staticClass: "flex flex-col gap-2",
              attrs: { handle: ".handle_section" },
              on: {
                update: function($event) {
                  $event.preventDefault()
                  return _vm.onMoveSection($event)
                }
              }
            },
            _vm._l(_vm.parentFormSections, function(section) {
              return _c(
                "div",
                { key: section.id, attrs: { id: section.id } },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "mb-2 py-1 px-2 w-full text-left flex justify-between gap-2 rounded border border-slate-400 cursor-default outline-none focus:border-light-purple"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "w-full flex gap-2 cursor-pointer",
                          on: {
                            click: function($event) {
                              return _vm.onScrollTo(
                                "section_field_" + section.id
                              )
                            }
                          }
                        },
                        [
                          _vm.movingSection
                            ? _c(
                                "div",
                                {
                                  staticClass: "handle_section pt-1 cursor-grab"
                                },
                                [
                                  _c("BlIcon", {
                                    staticClass: "h-4 w-4",
                                    attrs: { icon: "drag" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "h-6 w-6 flex-shrink-0 flex items-center justify-center rounded bg-red-salmon"
                            },
                            [
                              _c("BlIcon", {
                                staticClass: "w-4 h-4",
                                attrs: {
                                  icon: "rectangle-dashed",
                                  color: "white",
                                  tooltip: "Section"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("BlTextSubtitle3", {
                            staticClass: "pt-0.5",
                            attrs: { text: section.name }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "relative flex-shrink-0" },
                        [
                          _c("BlInputButton", {
                            staticClass:
                              "hover:bg-hover-state w-6 h-6 flex items-center justify-center",
                            attrs: { icon: "dots-vertical", type: "plain" },
                            on: {
                              clicked: function($event) {
                                _vm.menuOpened = "section_" + section.id
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.menuOpened === "section_" + section.id
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "absolute mr-4 top-0 right-full flex flex-col gap-1 bg-pure-white rounded border border-slate-400 p-2",
                                  style: { zIndex: 1 }
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "px-4 py-2 text-left min-w-48 outline-none rounded transition-all duration-300",
                                      class: [
                                        section.questions.length > 0
                                          ? "opacity-50 cursor-not-allowed"
                                          : "hover:bg-hover-state"
                                      ],
                                      attrs: {
                                        disabled: section.questions.length > 0
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.onRemoveSection(section.id)
                                        }
                                      }
                                    },
                                    [
                                      _c("BlTextBody2", {
                                        staticClass: "text-error-400",
                                        attrs: { text: "Delete section" }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.movingSection
                    ? _c("div", { staticClass: "pl-12.5" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "mt-2 py-1 px-2 flex items-center gap-2 rounded border border-slate-400"
                          },
                          [
                            _c("BlTextSubtitle3", {
                              attrs: {
                                text: section.questions.length + " block(s)"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _c(
                        "draggable",
                        {
                          staticClass:
                            "flex flex-col gap-2 mt-2 transition-all duration-300",
                          attrs: { handle: ".handle_question_" + section.id },
                          on: {
                            update: function($event) {
                              $event.preventDefault()
                              return _vm.onMoveQuestion($event)
                            }
                          }
                        },
                        _vm._l(section.questions, function(question) {
                          return _c(
                            "div",
                            {
                              key: question.id,
                              staticClass: "pl-12.5",
                              attrs: { id: section.id + "_" + question.id }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "py-1 px-2 w-full text-left flex justify-between gap-2 rounded border border-slate-400 outline-none cursor-default focus:border-light-purple"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-full flex gap-2 cursor-pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.onScrollTo(
                                            "question_field_" + question.id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "pt-1 cursor-grab",
                                          class: "handle_question_" + section.id
                                        },
                                        [
                                          _c("BlIcon", {
                                            staticClass: "h-4 w-4",
                                            attrs: { icon: "drag" }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "h-6 w-6 flex-shrink-0 flex items-center justify-center rounded bg-lime-500"
                                        },
                                        [
                                          _c("BlIcon", {
                                            staticClass: "w-4 h-4",
                                            attrs: {
                                              icon:
                                                _vm.iconInputs[
                                                  question.input_type
                                                ],
                                              color: "white",
                                              tooltip:
                                                _vm.tootipInputs[
                                                  question.input_type
                                                ]
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("BlTextSubtitle3", {
                                        staticClass: "pt-0.5",
                                        attrs: { text: question.label }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "relative flex-shrink-0" },
                                    [
                                      _c("BlInputButton", {
                                        staticClass:
                                          "hover:bg-hover-state w-6 h-6 flex items-center justify-center",
                                        attrs: {
                                          icon: "dots-vertical",
                                          type: "plain"
                                        },
                                        on: {
                                          clicked: function($event) {
                                            _vm.menuOpened =
                                              "question_" + question.id
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.menuOpened ===
                                      "question_" + question.id
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "absolute mr-4 top-0 right-full flex flex-col gap-1 bg-pure-white rounded border border-slate-400 p-2",
                                              style: { zIndex: 1 }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "px-4 pt-1 pb-2 text-left min-w-64 border-b border-slate-400"
                                                },
                                                [
                                                  _c("BlTextBody2", {
                                                    staticClass:
                                                      "text-slate-1000 font-bold",
                                                    attrs: {
                                                      text: "Move to section:"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.parentFormSections,
                                                function(item, idx) {
                                                  return _c(
                                                    "button",
                                                    {
                                                      key: item.id,
                                                      staticClass:
                                                        "px-4 py-2 text-left min-w-64 outline-none rounded transition-all duration-300",
                                                      class: [
                                                        item.id === section.id
                                                          ? "opacity-50 cursor-not-allowed"
                                                          : "hover:bg-hover-state"
                                                      ],
                                                      attrs: {
                                                        disabled:
                                                          item.id === section.id
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.onMoveToSection(
                                                            question.id,
                                                            item.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("BlTextBody2", {
                                                        staticClass:
                                                          "text-slate-1000",
                                                        attrs: {
                                                          text:
                                                            idx +
                                                            1 +
                                                            ". " +
                                                            item.name
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                ],
                1
              )
            }),
            0
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73dc775e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73dc775e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/salesPipeline/parentForm/Panel.vue
// module id = null
// module chunks = 